import { render } from "./Form.vue?vue&type=template&id=098c98f7"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Farmer/Form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "098c98f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('098c98f7', __exports__)) {
    console.log('reload')
    api.reload('098c98f7', __exports__)
  }
  
  module.hot.accept("./Form.vue?vue&type=template&id=098c98f7", () => {
    console.log('re-render')
    api.rerender('098c98f7', render)
  })

}


export default __exports__